import { serverHost } from "variables/serverdata";
import { getAuthToken } from "../../util/helpers";

// ------------------------ INSERT ------------------------
export async function insertAccessControl(accessControl, nodes, user_uuid) {
    const token = getAuthToken();

    const res = await fetch(`${serverHost}/create_access_control`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ accessControl, nodes, user_uuid }),
    });

    return res.json();
}

// ------------------------ UPDATE ------------------------
export async function updateAccessControl(accessControl, nodes, user_uuid) {
    if (!accessControl.access_control_uuid)
        throw new Error("Missing access_control_uuid");

    const token = getAuthToken();

    const res = await fetch(
        `${serverHost}/update_access_control/${accessControl.access_control_uuid}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ accessControl, nodes, user_uuid }),
        }
    );

    return res.json();
}

// ------------------------ GET SINGLE ------------------------
export async function getAccessControl(access_control_uuid) {
    const token = getAuthToken();
    const res = await fetch(`${serverHost}/get_access_control/${access_control_uuid}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || "Failed to fetch access control");
    }
    return res.json();
}

